import React from "react";

export default function OpenEye() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 60 45"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 22.5L11.5479 8.64247C16.1114 3.16627 22.8716 0 30 0C37.1284 0 43.8885 3.16627 48.4522 8.64247L60 22.5L48.4522 36.3574C43.8885 41.8339 37.1284 45 30 45C22.8716 45 16.1114 41.8339 11.5479 36.3574L0 22.5ZM30 33.75C36.2132 33.75 41.25 28.7132 41.25 22.5C41.25 16.2868 36.2132 11.25 30 11.25C23.7868 11.25 18.75 16.2868 18.75 22.5C18.75 28.7132 23.7868 33.75 30 33.75Z"
        fill="gray"
      />
    </svg>
  );
}
